var _defs, _path, _path2, _path3, _path4, _path5, _line, _ellipse, _g, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenMarginDistalNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_9",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 333.59 576.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #0c9748;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-3, .cls-4 {\n        stroke-width: 3px;\n      }\n\n      .cls-1, .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        stroke-width: 2.5px;\n      }\n\n      .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke: #009700;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M64.85,232.66c-1.05-38.81-6.29-69.41-11.09-90.71-9.47-42-21.22-65.54-11.09-90.71,5.29-13.13,16.66-27.02,27.73-25.92,5.58.56,12.39,5.06,27.73,38.87,14.74,32.49,12.22,36.65,22.18,58.31,17.8,38.73,33.66,42.46,41.59,74.51,4.23,17.09,3.74,32.3,2.77,42.11-11.39,3.74-28.73,7.78-49.91,6.48-21.64-1.33-38.83-7.72-49.91-12.96Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M142.49,190.31c-14.82-22.04-31.23-53.02-38.82-90.71-3.58-17.76-4.07-31.45,0-45.35,1.65-5.64,8.03-27.41,22.18-32.4,22.16-7.81,54.49,28.66,61,64.79,1.51,8.4,1.01,18.56,0,38.87-1.23,24.78-3.65,44.93-5.55,58.31-5.55,6.48-11.09,12.96-16.64,19.44-7.39-4.32-14.79-8.64-22.18-12.96Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M236.76,235.66c8.07-11.76,26.31-41.78,27.73-84.23,1.06-31.8-7.84-54.9-16.64-77.75-7.62-19.78-13.61-34.8-27.73-45.35-17.14-12.81-40.45-14.7-44.36-6.48-2.83,5.96,6.62,12.83,11.09,32.4,2.15,9.39,1.59,14.86,0,38.87-3.58,54.16-2.66,55.63-5.55,64.79-2.99,9.52-9,23.9-22.18,38.87v45.35c11.3.93,24.37,1.19,38.82,0,14.61-1.21,27.65-3.65,38.82-6.48Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M81.49,358.76c-5.24-3.52-10.87-7.78-16.64-12.96-12.18-10.93-21.21-22.51-27.73-32.4.28-9.27,1.4-23.02,5.55-38.87,5.52-21.13,8.47-32.38,16.64-38.87,15.65-12.44,31,8.11,72.09,6.48,18.73-.74,15.29-5,38.82-6.48,12.26-.77,19.85-.03,61,0,2.37,0,4.3,0,5.55,0,7.49,5.06,22.47,16.82,33.27,38.87,7.5,15.33,10.1,29.71,11.09,38.87-5.97,7.25-15.11,17.02-27.73,25.92-13.69,9.65-46.77,32.97-72.09,19.44-18.71-10-20.32-33.25-33.27-32.4-10.34.68-12.54,15.71-27.73,25.92-13.17,8.85-27.82,8.5-38.82,6.48Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.89,232.8s3.74-4.52,25.74,3.48c0,0,24.3,8.98,49.15,4.99,0,0,5.85-.99,8.85-1.99,0,0,7.42-2.74,16.71-3.37,0,0,7.29-.63,16.29-.63h55s-82.47,78.03-171.74-2.48Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 158.06,
    y1: 421.73,
    x2: 158.06,
    y2: 518.48
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 158.9,
    cy: 471.37,
    rx: 122.42,
    ry: 90.41
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 70.77,
    y1: 408.13,
    x2: 110.83,
    y2: 436.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 207.12,
    y1: 505.4,
    x2: 248.5,
    y2: 534.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 248.77,
    y1: 409.12,
    x2: 205.67,
    y2: 436.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 106.06,
    y1: 502.94,
    x2: 62.97,
    y2: 529.88
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 158.05,
    cy: 470.92,
    rx: 66.97,
    ry: 49.45
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "227.73 176.15 263.21 132.29 303.06 181.56 223.64 181.56 227.73 176.15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenMarginDistalNew);
export default __webpack_public_path__ + "static/media/OpenMarginDistalNEW.5c927236b4ac4f44c1901d9984d2f5d3.svg";
export { ForwardRef as ReactComponent };